// Loudness-match gain math (Req 4.4, 4.5). Extracted so the unified player and any tests can
// share it without pulling in a React component.

const DBTP_CEILING = -1; // -1 dBTP ceiling (design)

/**
 * Loudness-match gain (in dB) for one version:
 *   gainDb = loudnessRef - integratedLufs, clamped so truePeak + gainDb <= ceiling.
 * Returns 0 (unity) when the integrated loudness measurement is missing.
 */
export function matchGainDb(
  integratedLufs: number | null,
  truePeakDbtp: number | null,
  loudnessRef: number,
  ceiling = DBTP_CEILING
): number {
  if (integratedLufs == null) return 0;
  let g = loudnessRef - integratedLufs;
  if (truePeakDbtp != null) {
    const maxByPeak = ceiling - truePeakDbtp; // largest gain that keeps TP <= ceiling
    g = Math.min(g, maxByPeak);
  }
  return g;
}
